/*
 * Action Types
 */
export enum VoucherTypes {
  TOGGLE_VOUCHER = '@voucher/TOGGLE_VOUCHER',
}

/*
 * State type
 */
export interface VoucherState {
  readonly voucher: boolean | null;
}
